module.exports = __webpack_public_path__ + "static/media/OVER.24d5dcda.png";